import React, { createContext, useState, useContext } from "react";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const RecommendationContext = createContext();
export const RecommendationProvider = ({ children }) => {
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const [commodities, setCommodities] = useState([]);

  const setCommoditiesData = (data) => {
    setCommodities(data);
  };
  const setRecommendation = (data) => {
    setSelectedRecommendation(data);
  };

  return (
    <RecommendationContext.Provider
      value={{
        selectedRecommendation,
        setRecommendation,
        commodities,
        setCommoditiesData,
      }}
    >
      {children}
    </RecommendationContext.Provider>
  );
};

export const useRecommendation = () => useContext(RecommendationContext);
